import { render } from "./CicoTag.vue?vue&type=template&id=0c0401d3&scoped=true"
import script from "./CicoTag.vue?vue&type=script&lang=js"
export * from "./CicoTag.vue?vue&type=script&lang=js"

import "./CicoTag.vue?vue&type=style&index=0&id=0c0401d3&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0401d3"]])

export default __exports__